import React from 'react';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const ICON_STYLE = {
  check: { fontSize: '20px', color: '#16B364' },
  close: { fontSize: '20px', color: '#1E164EA3' },
};

const CheckOrCross = ({ isCheck }) => (
  <div>
    {isCheck ? (
      <CheckCircleRoundedIcon style={ICON_STYLE.check} />
    ) : (
      <CloseRoundedIcon style={ICON_STYLE.close} />
    )}
  </div>
);

export default CheckOrCross;
